import { useRestaurantContext } from 'webReservations/context/RestaurantContext';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { getRestaurantEventDisclaimers } from './apiHelpers';

export const useFetchRestaurantEventDisclaimers = (
  restaurantEventId: string | undefined,
) => {
  const { restaurantDetails } = useRestaurantContext();

  return useQuery({
    queryKey: [
      restaurantDetails.id,
      restaurantEventId,
      'restaurantEventDisclaimers',
    ],
    queryFn: async () => {
      return getRestaurantEventDisclaimers({
        restaurantId: restaurantDetails.id,
        restaurantEventId: restaurantEventId as string,
      });
    },
    enabled: !!restaurantEventId,
    initialData: [],
  });
};

export const useRestaurantEventDisclaimerValidation = (
  restaurantEventId: string | undefined,
) => {
  const { data: disclaimers } =
    useFetchRestaurantEventDisclaimers(restaurantEventId);
  const [disclaimerFormState, setDisclaimerFormState] = useState<
    Record<string, boolean>
  >({});

  useEffect(() => {
    const initialState = disclaimers.reduce(
      (acc, disclaimer) => {
        acc[disclaimer.id] = false;
        return acc;
      },
      {} as Record<string, boolean>,
    );
    setDisclaimerFormState(initialState);
  }, [disclaimers]);

  const allDisclaimersChecked = (disclaimers || []).every(
    (disclaimer) => disclaimerFormState[disclaimer.id],
  );

  const handleDisclaimerToggle = (disclaimerId: string, checked: boolean) => {
    setDisclaimerFormState((prev) => ({
      ...prev,
      [disclaimerId]: checked,
    }));
  };

  return {
    allDisclaimersChecked,
    isDisclaimerChecked: (id: string) => disclaimerFormState[id] || false,
    handleDisclaimerToggle,
  };
};
